export default __webpack_public_path__ + "static/media/titleHTP.d07a58f5.png";